import React, { useEffect, useMemo, forwardRef } from "react";
import Plot from "react-plotly.js";

const PlotComponent = forwardRef(
  ({ plotKey, data, layout, config, plotTitles }, plotRef) => {
    const memoizedLayout = useMemo(() => {
      return {
        ...layout,
        autosize: true,
        title: {
          text: plotTitles?.main_title || "",
          x: 0.5,
          xanchor: "center",
          font: { size: 16, weight: 600, color: "#1B72B7" },
        },
        margin: { t: 80, b: 60, l: 60, r: 60 },
        xaxis: {
          ...layout?.xaxis,
          title: {
            text: plotTitles?.x_axis_title || "",
            font: { size: 16, weight: 600 },
            standoff: 20,
          },
        },
        yaxis: {
          ...layout?.yaxis,
          title: {
            text: plotTitles?.y_axis_title || "",
            font: { size: 16, weight: 600 },
          },
        },
      };
    }, [layout, plotTitles]);

    // Attach resize listener only once
    useEffect(() => {
      const handleResize = () => {
        if (plotRef?.current?.resizeHandler) {
          plotRef.current.resizeHandler();
        }
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [plotRef]);

    return (
      <Plot
        key={plotKey}
        data={data}
        layout={memoizedLayout}
        config={{
          ...config,
          responsive: true,
          scrollZoom: true,
          displaylogo: false,
        }}
        useResizeHandler
        ref={plotRef}
        style={{ width: "100%", height: "100%" }}
      />
    );
  }
);

// Memoize the component to prevent unnecessary re-renders when props are unchanged
export default React.memo(PlotComponent, (prevProps, nextProps) => {
  return (
    prevProps.plotKey === nextProps.plotKey &&
    prevProps.data === nextProps.data &&
    prevProps.layout === nextProps.layout &&
    prevProps.config === nextProps.config &&
    prevProps.plotTitles === nextProps.plotTitles
  );
});
